export default {
  updateAll(state, value) {
    state.all = value
  },
  updateSingle(state, value) {
    state.single = value
  },
  updateSupportingData(state, value) {
    state.supportingData = value
  }
}
